import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue')
  },{
    path:'/chat',
    name:'chat',
    component:()=>import('../views/chat/index.vue')
  },{
    path:'/personal',
    name:'personal',
    component:()=>import('../views/chat/personal.vue')
  },{
    path:'/rechargeCredit',
    name:'rechargeCredit',
    component:()=>import('../views/chat/rechargeCredit.vue')
  },{
    path:'/drCode',
    name:'drCode',
    component:()=>import('../views/login/drCode.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router